import Cookies from 'js-cookie';

// 基础配置
const BASE_CONFIG = {
  // baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'https://api.heckai.weight-wave.com/api',
  // baseURL: 'https://api.heck.ai/api',
  // baseURL: '/api',
  baseURL: 'https://api.heckai.weight-wave.com/api',
  timeout: 10000,
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpZCI6IjQ0ZWY1OWM2LWU4YTYtNGE4YS1hZGEyLWNhYmZiN2EyNDY3MCIsImVtYWlsIjoiemhlbmd6aGFvemhhbzExNTA4QGdtYWlsLmNvbSIsInR5cGUiOiJhY2Nlc3MiLCJpYXQiOjE3Mzk1OTQ4NzQsImV4cCI6MTczOTY4MTI3NH0.0TiHqarMo8xbBy2KIIyS4-VqDC9FzYy07WgBOooH6OY"
    // 读取 localStorage 中的 token
    'Authorization': (typeof window !== "undefined" && localStorage.getItem('token')) ? `Bearer ${localStorage.getItem('token')}` : '',
  }
};

// 处理请求 URL
const resolveURL = (url) => {
  if (url.startsWith('http')) {
    return url;
  }
  return `${BASE_CONFIG.baseURL}${url.startsWith('/') ? url : `/${url}`}`;
};

// 处理 GET 请求的参数
const handleGetParams = (url, params) => {
  if (!params || Object.keys(params).length === 0) {
    return url;
  }
  const searchParams = new URLSearchParams(params).toString();
  return `${url}${url.includes('?') ? '&' : '?'}${searchParams}`;
};

// 错误处理
const handleError = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage;
    try {
      const errorJson = JSON.parse(errorText);
      errorMessage = errorJson.message || errorText;
    } catch {
      errorMessage = errorText;
    }
    // 错误包装处理后面处理
    // throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorMessage}`);
    throw {
      status: response.status,
      errorMessage: errorMessage
    };
  }
  return response;
};

// 核心请求方法
const request = async (url, options = {}) => {
  const finalURL = resolveURL(url);
  // const session = Cookies.get('session');
  
  const finalOptions = {
    ...BASE_CONFIG,
    ...options,
    headers: {
      ...BASE_CONFIG.headers,
      ...options.headers,
      // ...(session && {
      //   'Cookie': `session=${session}; Path=/; Domain=.aiapilab.com; SameSite=None`
      // })
    }
  };

  // 处理 GET 请求的参数
  if (finalOptions.method === 'GET' && finalOptions.body) {
    const processedURL = handleGetParams(finalURL, finalOptions.body);
    delete finalOptions.body;
    
    try {
      const response = await fetch(processedURL, finalOptions);
      await handleError(response);
      return await response.json();
    } catch (error) {
      console.error('API Request Failed:', error);
      throw error;
    }
  }

  // 处理非 GET 请求
  try {
    const response = await fetch(finalURL, finalOptions);
    await handleError(response);
    return await response.json();
  } catch (error) {
    console.error('API Request Failed:', error);
    throw error;
  }
};

// API 方法
const api = {
  get: (url, params = {}, options = {}) =>
    request(url, { ...options, method: 'GET', body: params }),
    
  post: (url, data = {}, options = {}) =>
    request(url, { 
      ...options, 
      method: 'POST', 
      body: JSON.stringify(data) 
    }),
    
  put: (url, data = {}, options = {}) =>
    request(url, { 
      ...options, 
      method: 'PUT', 
      body: JSON.stringify(data) 
    }),
    
  delete: (url, data = {}, options = {}) =>
    request(url, { 
      ...options, 
      method: 'DELETE', 
      body: JSON.stringify(data) 
    })
};

export default api;